import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function HppOnly({ children, superAdmin = false }) {
  const { user } = useAuth();
  if (!user) return null;
  const ok = user.role === "super_admin" || (user.module_access || ["keuangan"]).includes("hpp");
  if (!ok) return <Navigate to="/" replace />;
  if (superAdmin && user.role !== "super_admin") return <Navigate to="/hpp" replace />;
  return children;
}
